import axios from "axios";
import { enqueue, replayQueue } from "./offline";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("ps_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Offline queue: catch network errors on mutations and queue them.
api.interceptors.response.use(
  (resp) => resp,
  (error) => {
    const cfg = error.config || {};
    const method = (cfg.method || "get").toLowerCase();
    const isMutation = ["post", "put", "patch", "delete"].includes(method);
    const offline = !navigator.onLine || (!error.response && error.message?.includes("Network"));
    // Skip queuing for auth + dev endpoints
    const skip = /\/auth\/|\/dev\//.test(cfg.url || "");
    if (isMutation && offline && !skip) {
      enqueue({
        method,
        url: cfg.url,
        data: cfg.data ? (typeof cfg.data === "string" ? JSON.parse(cfg.data) : cfg.data) : undefined,
        headers: { "Content-Type": cfg.headers?.["Content-Type"] || "application/json" },
      });
      return Promise.resolve({
        data: { offline: true, queued: true, message: "Action mise en file — sera synchronisée au retour réseau" },
        status: 202,
        statusText: "Queued offline",
      });
    }
    return Promise.reject(error);
  }
);

// Auto-replay queue on reconnect
if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    replayQueue(api);
  });
}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" — ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
